module.exports = __webpack_public_path__ + "static/media/fly0088.8823203e.webp";